import { useGetPartnerHierarchy } from '@/features/lp-village/partners/api/getPartnerHierarchy';
import { ILPPartnerState } from '@/features/lp-village/partners/api/useLPPartner';
import useLPPartner from '@/features/lp-village/partners/api/useLPPartner';

type UsePartnerOrgBlockerViewResult = {
  partnerState: ILPPartnerState;
  isMasterAccount: boolean;
  isAssociatedToCompany: boolean;
  hasChildren: boolean;
  isOrgBlocker: boolean;
};

export const usePartnerOrgBlockerView = (
  partnerId: string
): UsePartnerOrgBlockerViewResult => {
  const { partnerState } = useLPPartner(partnerId);

  const isMasterAccount = !!partnerState.data.master_account_enabled;
  const isAssociatedToCompany = !!partnerState.data.parent_id;

  const { data: hierarchy } = useGetPartnerHierarchy(partnerId, {
    enabled: isMasterAccount,
  });

  const hasChildren = (hierarchy?.children?.length ?? 0) > 0;
  const isOrgBlocker =
    (isMasterAccount && hasChildren) || isAssociatedToCompany;

  return {
    partnerState,
    isMasterAccount,
    isAssociatedToCompany,
    hasChildren,
    isOrgBlocker,
  };
};
